__turbopack_context__.v({
  "banner": "style-module-scss-module__1M8apG__banner",
  "banner_desktop": "style-module-scss-module__1M8apG__banner_desktop",
  "banner_mobile": "style-module-scss-module__1M8apG__banner_mobile",
  "banner_section": "style-module-scss-module__1M8apG__banner_section",
  "root": "style-module-scss-module__1M8apG__root",
  "summary": "style-module-scss-module__1M8apG__summary",
  "wrapper": "style-module-scss-module__1M8apG__wrapper",
});
